import { TSelectedTrainType } from './train-type';

export type TTariffProfile = {
  id: number;
  name: string;
  trainType: TSelectedTrainType;
  fromPayDate?: string | null; // Действует с даты оплаты (null - не использовать условие)
  toPayDate?: string | null; // Действует по дату оплаты (null - не использовать условие)
  fromTripDate?: string | null; // Действует с даты начала рейса (null - не использовать условие)
  toTripDate?: string | null; // Действует по дату начала рейса (null - не использовать условие)
  rules: TTariffProfileRule[];
};

// 0 - наценка, 1 - скидка, 2 - фиксированная цена)
export const enum ETariffProfileRuleType {
  increase = 0,
  decrease = 1,
  fixed = 2,
}

export type TTariffProfileRule = {
  zoneId: number;
  tariffTypeId: number;
  type: ETariffProfileRuleType | null;
  terminalTypeId: number | null;
  amount: number | null;
  percent: number | null;
};

export type TNewTariffProfile = Omit<Partial<TTariffProfile>, 'id' | 'name'> & {
  name: TTariffProfile['name'];
  trainType: TSelectedTrainType;
};
